<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Feedback Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
           <v-col cols="12" sm="2"></v-col>
                <v-col cols="12" sm="2">
                    <p><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined />
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Feedback Version</b></p>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="feedback_version" :items="feedback_version_list" item-text="feedback_number" item-value="id" label="Feedback Version" outlined />
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Instructor</b></p>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col>
                 <v-col cols="12" sm="2">
                     <p><br></p>
                   <v-btn color="primary" @click="fetch()"  dense rounded  :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense>
               
            </v-row>
       </v-card>

        <v-card class="box" v-for="(item) in feedback_response_details" :key="item.id">
            <v-row justify="center" dense >
                <v-col cols="12" sm="1">
                    <p><b>Standard:</b>{{item.standard}}</p>
                </v-col>
                <v-col cols="12" sm="1">
                    <p><b>Division:</b>{{item.division}}</p>
                </v-col>
                <v-col cols="12" sm="2">
                    <p><b>Subject:</b>{{item.course}}</p>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Employee:</b>{{item.courseofferinginstructor}}</p>
                </v-col>
                <v-col cols="12" sm="1">
                    <p><b>AY:</b>{{item.ay}}</p>
                </v-col>
                <v-col cols="12" sm="1">
                    <p><b>Feedback No:</b>{{item.feedback_number}}</p>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Date:</b>{{item.feedback_date}}</p>
                </v-col>
                <v-col cols="12" sm="3">
                    <p v-html="item.question">Question:{{item.question}}</p>
                </v-col>
           </v-row>
        </v-card> 
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      title:"",
      description:"",
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
      ay_list:[],ay:"",feedback_version_list:[],feedback_version:"",instructor_list:[],instructor:"",feedback_response_details:[]
  }),
   methods: {
    fetch(){
       this.loader=true
        const formData = {
            ay:this.ay,
            feedback_version:this.feedback_version,
            instructor:this.instructor
        };
        axios
        .post("/Feedback/fetchReport",formData)
        .then((res) => {
            if (res.data.flag == "Yes") {
             this.feedback_response_details=res.data.feedback_response_details
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {
        this.loader=false
    });
    },

    onLoad(){
     axios
    .get("/Feedback/getInitialData")
    .then((res) => {
        if (res.data.flag == "Yes") {
          this.ay_list=res.data.ay_list,
           this.ay=res.data.curreny_ay,
           this.feedback_version=res.data.current_version
           this.feedback_version_list=res.data.feedback_version_list
           this.instructor_list=res.data.instructor_list
        } 
        else {
        this.showSnackbar("#b71c1c", "Wrong information");   
        }
    })
    .catch((error) => {
        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
    })
    .finally(() => {
        // 'use strict';
    });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>